import { render, staticRenderFns } from "./WorkspaceMenubar.vue?vue&type=template&id=339c5060&scoped=true&"
import script from "./WorkspaceMenubar.vue?vue&type=script&lang=js&"
export * from "./WorkspaceMenubar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339c5060",
  null
  
)

export default component.exports